var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.878 3.021C23.9541 3.16312 23.9939 3.32181 23.994 3.483C24 3.48901 24 3.49399 24 3.5V20C24 20.8284 23.3284 21.5 22.5 21.5H19.5C18.6716 21.5 18 20.8284 18 20V11.5H2C0.895432 11.5 0 10.6046 0 9.5V4.5C0 3.39542 0.895432 2.5 2 2.5H23C23.366 2.49994 23.7027 2.69977 23.878 3.021ZM2 9C2 9.27615 2.22386 9.5 2.5 9.5H17.678C17.8484 9.50006 18.007 9.41339 18.099 9.26999L20.67 5.26999C20.7686 5.11624 20.7756 4.92093 20.6881 4.76056C20.6006 4.60022 20.4327 4.50031 20.25 4.5H18.75C18.4739 4.5 18.25 4.72385 18.25 5V6C18.25 6.41422 17.9142 6.75 17.5 6.75C17.0858 6.75 16.75 6.41422 16.75 6V5C16.75 4.72385 16.5261 4.5 16.25 4.5H15.25C14.9739 4.5 14.75 4.72385 14.75 5V6C14.75 6.41422 14.4142 6.75 14 6.75C13.5858 6.75 13.25 6.41422 13.25 6V5C13.25 4.72385 13.0261 4.5 12.75 4.5H11.75C11.4739 4.5 11.25 4.72385 11.25 5V6C11.25 6.41422 10.9142 6.75 10.5 6.75C10.0858 6.75 9.75 6.41422 9.75 6V5C9.75 4.72385 9.52614 4.5 9.25 4.5H8.25C7.97386 4.5 7.75 4.72385 7.75 5V6C7.75 6.41422 7.41422 6.75 7 6.75C6.58578 6.75 6.25 6.41422 6.25 6V5C6.25 4.72385 6.02614 4.5 5.75 4.5H2.5C2.22386 4.5 2 4.72385 2 5V9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4.55228 8 5 7.55228 5 7C5 6.44772 4.55228 6 4 6C3.44772 6 3 6.44772 3 7C3 7.55228 3.44772 8 4 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasure);
export default __webpack_public_path__ + "static/media/measure.4e8e2188.svg";
export { ForwardRef as ReactComponent };